import { z } from "zod";
import { uuidSchema } from "./validation-common";

// Common param schemas

export const IdParamSchema = z.object({
  id: uuidSchema,
});

export const CompanyIdParamSchema = z.object({
  companyId: uuidSchema,
});


